document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('employee-modal');
    const modalEmployeeName = document.getElementById('modal-employee-name');
    const modalEmployeeTitle = document.getElementById('modal-employee-title');
    const modalEmployeeEmail = document.getElementById('modal-employee-email');
    const modalEmployeeDescription = document.getElementById('modal-employee-description');
    const modalLinkedin = document.getElementById('modal-linkedin');
    const modalBackgroundImage = document.getElementById('modal-background-image');
  
    const buttons = document.querySelectorAll('.button-a-propos');
  
    buttons.forEach(button => {
      button.addEventListener('click', function () {
        const employeeId = this.getAttribute('data-employee-id');
        
        const block = document.querySelector(`[data-employee-id="${employeeId}"]`);
        
        modalEmployeeName.textContent = block.getAttribute('data-employee-name');
        modalEmployeeTitle.textContent = block.getAttribute('data-employee-title');
        modalEmployeeEmail.textContent = block.getAttribute('data-employee-email');
        modalEmployeeEmail.setAttribute('href', 'mailto:' + block.getAttribute('data-employee-email'));
        modalEmployeeDescription.textContent = block.getAttribute('data-employee-description');
        modalLinkedin.setAttribute('href', block.getAttribute('data-employee-linkedin'));
        modalBackgroundImage.setAttribute('src', block.getAttribute('data-employee-background'));
  
        modal.style.display = 'flex';
      });
    });
  
    const closeButton = document.getElementById('modal-close');
    closeButton.addEventListener('click', function () {
      modal.style.display = 'none';
    });
  
    window.addEventListener('click', function (event) {
      if (event.target === modal) {
        modal.style.display = 'none';
      }
    });
  });
  